import React from 'react';

const USACodebook = () => {
  return (
    <div style={{ height: '100vh', width: '100%' }}>
      <iframe
        src="/ICD-10-CM_with_hyperlinks.html"
        title="USA Book"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
};

export default USACodebook;

